/**Форматирование даты */
export const formatDate = (date: Date) => {
  return `${formatNumber(date.getDate())}.${formatNumber(date.getMonth() + 1)}.${date.getFullYear()} в ${formatNumber(date.getHours())}:${formatNumber(date.getMinutes())}`;
};
/**Форматирование чилса */
export const formatNumber = (num: number) => {
  return num.toString().length === 2 ? num.toString() : `0${num}`;
};
